import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M18.5 2H5.5C4.395 2 3 2.895 3 4V10.377C3 10.897 3.452 11.396 3.814 11.769L4.561 12.668C4.923 13.041 5 13.541 5 14.06V20C5 21.105 6.395 22 7.5 22H18.5C19.605 22 20 21.105 20 20V4C20 2.895 19.605 2 18.5 2ZM9 20H7V16H9V20ZM12 20H10V16H12V20ZM15 20H13V16H15V20ZM18 20H16V16H18V20Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'MemoryCardFill');

export default Icon;
